import { UsersRound, MessagesSquare, Coins, UserRound } from 'lucide-react';

import { ROUTES, isVisitPath, isChatPath } from './routes.js';

// THE destination list — one copy, two shells.
//
// The desktop rail (src/components/common/StudentLayout) and the mobile bottom
// bar (src/components/mobile/MobileShell) render the SAME four destinations, and
// two hand-kept lists is exactly how a bar and a rail drift apart. Neither shell
// may declare its own; tests/routing.test.js asserts both import this one.
//
// FOUR ENTRIES — بیماران · گفتگو · پارسه · پروفایل (core.md §7.0). Four is also
// the ceiling the mobile design concept sets for a bottom bar. A patient record,
// a visit and a chat page are reached FROM a patient, not from a destination.
//
// `labelKey`, not `label`: navigation is chrome that follows the UI language, and
// this list is module-level so it cannot call a hook itself. `Icon` is a
// component, not a rendered node: the rail draws it at 20px and the bottom bar
// at 22px.
export const NAV_ITEMS = [
  { id: 'patients', labelKey: 'nav.items.patients', Icon: UsersRound },
  { id: 'chatLanding', labelKey: 'nav.items.chat', Icon: MessagesSquare },
  { id: 'credits', labelKey: 'nav.items.credits', Icon: Coins },
  { id: 'profile', labelKey: 'nav.items.profile', Icon: UserRound },
];

/**
 * Which destination is lit for a path.
 *
 * A patient's chat page lights «گفتگو» (it IS the chat feature); the record and
 * the visit light «بیماران». `/` redirects to `/patients` and lights it too.
 */
export function activeNavFor(pathname) {
  const p = String(pathname || '/');
  if (p === '/chat' || p.startsWith('/chat/') || isChatPath(p)) return 'chatLanding';
  if (p === '/' || p.startsWith('/patients')) return 'patients';
  if (p.startsWith('/credits')) return 'credits';
  if (p.startsWith('/profile')) return 'profile';
  return null;
}

/**
 * The paths that are TOP-LEVEL mobile destinations — exactly one per NAV_ITEMS
 * id, which tests/routing.test.js pins.
 */
export const BOTTOM_NAV_PATHS = NAV_ITEMS.map((item) => ROUTES[item.id]());

/**
 * Is this path one of the four top-level destinations?
 *
 * The trailing slash is stripped first: React Router matches `/credits/`
 * against `<Route path="/credits">`, but `useLocation().pathname` hands the URL
 * back verbatim, and an exact `includes` would answer false for a screen that is
 * on the display.
 */
export const isTopLevelPath = (pathname) => {
  const normalized = String(pathname || '/').replace(/\/+$/, '') || '/';
  return BOTTOM_NAV_PATHS.includes(normalized);
};

/**
 * Does the mobile bottom bar render on this path?
 *
 * core.md §7.0: the bar is hidden on `/patients/:id/visit/*` and
 * `/patients/:id/chat/*` — full-height workspaces with their own back button. A
 * bar on the chat page would offer «پارسه» as an escape from an answer the
 * student has already paid for and not yet read. Everywhere else (the list, the
 * record, the wallet, the profile) it stays.
 */
export const showsBottomNav = (pathname) => !isVisitPath(pathname) && !isChatPath(pathname);

export default NAV_ITEMS;
